import { cssVar } from '@chakra-ui/styled-system';

const arrowBackground = cssVar("popper-arrow-bg");
const arrowBorder = cssVar("popper-arrow-shadow-color");
const Tooltip = {
  baseStyle: {
    [arrowBorder.variable]: "transparent",
    [arrowBackground.variable]: "black",
    border: "1px solid",
    borderColor: "transparent",
    maxWidth: "17rem",
    backgroundColor: "black",
    textAlign: "center",
    borderRadius: "tooltip",
    padding: "75",
    color: "white",
    zIndex: "tooltip",
    _dark: {
      [arrowBorder.variable]: "var(--vimeo-colors-stroke)",
      borderColor: "stroke"
    }
  },
  variants: {
    "speech-bubble": {
      padding: "300",
      boxShadow: "rgba(0, 0, 0, 0.1) 0 0 0.5rem -0.25rem, rgba(0, 0, 0, 0.15) 0 0.75rem 0.75rem -0.75rem"
    }
  }
};

export { Tooltip };
